<template>
  <!--
  플랫폼 페이지 : Search, 소개, 공정도, 프로토콜, 마이페이지 등
 -->
  <!-- 2023-10-11 퍼블 수정 => 메인화면에서만 main_bg 클래스 붙게 수정 -->
  <!-- 2023-10-12 퍼블 수정 => account 화면에서 login_bg 클래스 붙게 수정 -->
  <div class="minH"
       :class="[$route.path != '/platform/search' && ($route.path === '/' || $route.path === '/platform') ? 'main_bg' : ''
                , $route.path !== 'platform/search' && $route.path.match('/account/login') ? 'login_bg' : ''
                ]"
  >

  <!-- popup -->
  <OrgCodeInput></OrgCodeInput>
  <!-- popup -->

  <div class="wrap">
    <HubHeader />
    <div :class="[$route.path != '/platform' ? 'ptc_container' : '']">
      <router-view />
    </div>
    <!-- !main -->
    <!-- footer -->
    <footer class="footer">
    <div class="inner">
      <ul class="floating_btn">
<!--        <li v-if="user != null && user?.assistant == false && user?.committee == false && user?.admin == false && user?.super == false && user?.generalManager == false">
          <button type="button" class="st_01" @click="registerConfirm"><em>간사·위원 등록신청</em></button>
        </li>-->
      </ul>
      <div class="footer_cont">
        <ul class="family_site align_rt">
          <li><a target="_blank" href="https://kist.re.kr/">KIST</a></li>
          <li><a target="_blank" href="https://www.kier.re.kr/">KIER</a></li>
        </ul>
        <div class="align_lt">
          <ul class="footer_link">
            <li><router-link :to="{ path: '/terms', query: { type: 'PRIVACY' } }">개인정보처리방침</router-link></li>
            <li><router-link :to="{ path: '/terms', query: { type: 'TERM' } }">플랫폼 이용약관</router-link></li>
            <li><a href="#" @click="handleClick">공정도 작성</a></li>
            <li><a class="tutorial_down" href="/m3dhub/tutorial/Hub_Manual.pdf" target="_blank" download>튜토리얼 다운로드</a></li>
          </ul>
          <div class="address_tel">
            <address>[02792] 서울특별시 성북구 화랑로 14길 5</address>
            <span>TEL : 02-958-5930</span>
            <span>FAX : 02-958-5969/02-958-5969</span>
          </div>
          <p class="copyright">COPYRIGHTⓒ2025 BY KIST ALL RIGHTS RESERVED</p>
        </div>
      </div>
    </div>
    </footer>
    <!-- footer : E -->
  </div>
  </div>
</template>

<script>
import getToken from "@/plugins/wApi/lib/getToken";
import OrgCodeInput from "@modal/OrgCodeInput";
import HubHeader from "@/components/layout/HubHeader.vue";
export default {
  components: {OrgCodeInput, HubHeader},
  data() {
    return {
      termsPopObj : {
        openBln : false ,
        closeHandler : _=> {
          this.termsPopObj.openBln = false ;
        } ,
      } ,
      // 검색중
      searching: false,
      // 검색어
      str: null,
    };
  },
  watch: {
    $route(n) {
      if(this.user && (this.user.companyCode == null || this.user.companyCode=="")){
        this.$store.commit("Hub/setOrgCodeInputPopFlag", true);
      }
    },
  },
  computed: {
    user() {
      return this.$store.state.user?.error? null : this.$store.state.user;
    },
  },
  mounted() {
    if(this.user && (this.user.companyCode == null || this.user.companyCode=="")){
      this.$store.commit("Hub/setOrgCodeInputPopFlag", true);
    }
  },
  methods: {
    async getMe() {
      if (getToken().Authorization) {
        const user = await this.$wApi.user.me();
        this.$store.commit("setState", ["user", user]);
      } else {
        this.$store.commit("setState", ["user", null]);
      }
    },
    handleClick() {
      // console.log( "this.user", this.user )
      if( this.user && !this.user.admin && !this.user.committee && !this.user.super && !this.user.generalManager ){
        window.alert( "공정도관리자가 아닌 유저는 공정도 작성이 불가합니다." );
      }else if (this.user) window.open(this.$router.resolve("/process/gate").href);
      else this.$router.push("/account/login");

      // if (this.user) this.$router.push("/process/gate");
      // else this.$router.push("/account/login");
    },
    termsClickHandler () {
      this.termsPopObj = { ...this.termsPopObj , openBln : true } ;
    } ,
    search(str) {
      console.log("%cPlatform.vue line:287 str", "color: #007acc;", str);
    },
    async registerConfirm() {
      await this.getMe();
      if(this.user == null){
        this.$router.push("/account/login");
        return;
      }
      if(  this.user?.assistant       == true
        || this.user?.committee       == true
        || this.user?.admin           == true
        || this.user?.super           == true
        || this.user?.generalManager  == true){
        const msg = "이미 신청 완료된 회원 입니다.";
        await window.alert(msg);
        return;
      }
      const bool = await window.confirm(
        "간사,위원으로 등록하면 공정도와 프로토콜 작성 전문가 활동을 할 수 있습니다.<br>등록하시겠습니까?",
        false,
        {
          okTitle: "등록하기",
          okVariant:
            "platform confirm-btn text-14 text-center py-2 px-4 mx-2 mb-2 text-nowrap",
        }
      );
      if (bool) {
        this.$router.push("/register-application");
      }
    },
  },
};
</script>

<style scoped>
@import "@/style/new/css/ui.reset.css";
@import "@/style/new/css/ui.common.css";
.login_pop{
  position: fixed;
  z-index: 10;
  left: 0; top: 0; width: 100%; height: 100%;
  display: flex;
  justify-content: center; align-items: center;
  visibility: hidden;
  transition: visibility 0.475s , backdrop-filter 0.475s;
  backdrop-filter: blur( 0px );
}
</style>
